/**
 * RealmTracker
 * ---------------------------------------------------------------
 * Lightweight helper that watches URL changes and infers the
 * currently active "realm" (user | carrier).
 *
 * Result is stored in localStorage(STORAGE_ACTIVE_REALM).
 *
 * Used by:
 *  - Auth providers
 *  - Guards
 *  - UI components wishing to adapt to realm
 *
 * NOTE: Works seamlessly with HashRouter since pathname already
 *       excludes the hash prefix ("#/carrier/home" -> pathname="/carrier/home").
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { STORAGE_ACTIVE_REALM } from './storageKeys';

export default function RealmTracker() {
  // With HashRouter -> pathname is always the part *after* "#"
  const { pathname } = useLocation();

  useEffect(() => {
    // Normalize to guarantee robustness
    const safePath = pathname || '';

    // Detect realm only by prefix
    const nextRealm = safePath.startsWith('/carrier') ? 'carrier' : 'user';

    try {
      const prevRealm = localStorage.getItem(STORAGE_ACTIVE_REALM);

      // Avoid redundant writes
      if (prevRealm !== nextRealm) {
        localStorage.setItem(STORAGE_ACTIVE_REALM, nextRealm);
      }
    } catch {
      // ignore storage failures (private browsing, quota exceeded, etc.)
    }
  }, [pathname]);

  // No UI
  return null;
}
